import moment from "moment";

function formatDate(dateInput) {
  if (!dateInput) {
    return "";
  }

  const parsedDate = moment(dateInput);

  if (!parsedDate.isValid()) {
    return "";
  }

  const formattedDate = parsedDate.format("DD-MM-YYYY");
  return formattedDate;
}

export default formatDate;
